
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 200.27 186"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M0 0h200.27v186H0z"}})]),_c('clipPath',{attrs:{"id":"clip-path-2"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M-266.88 520h1920v1080h-1920z"}})])]),_c('g',{attrs:{"clip-path":"url(#clip-path)","id":"oneTimeInspiration2"}},[_c('path',{attrs:{"fill":"#00213d","d":"M0 0h200.27v186H0z"}}),_c('path',{attrs:{"id":"transformEl2","d":"M154.19 1.21l-29 51.06a23.12 23.12 0 00-2.32 15.41 21 21 0 003.71 7.84c5.74 8 39.38 49.46 85.86 105.67 8.7 7.82 19 7.37 22.58 2.89V171.7L230.8 0z","fill":"#0092ff"}}),_c('path',{attrs:{"id":"transformEl","d":"M27.68 0c5.23 5.29 80.26 91.85 96.76 120.62 5 8.75 7 23.61 1.75 35.79a33.48 33.48 0 01-9.91 12.8l-70.17 57.53h-106.6V0z","fill":"#00317f"}})])])
          )
        }
      }
    